import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Save a health record to the signed-in user's private, server-side history.
// No-op (returns false) when signed out — records are never written to
// plain localStorage.
export const saveRecord = async ({ type, title, summary = "", score = null, payload = {}, inputs = {} }) => {
  try {
    await axios.post(
      `${API}/records`,
      { type, title, summary, score, payload, inputs },
      { withCredentials: true }
    );
    return true;
  } catch {
    return false;
  }
};

export const listRecords = async (type) => {
  const { data } = await axios.get(`${API}/records${type ? `?type=${type}` : ""}`, {
    withCredentials: true,
  });
  return data.records || [];
};

export const getRecord = async (recordId) => {
  const { data } = await axios.get(`${API}/records/${recordId}`, { withCredentials: true });
  return data.record;
};

export const deleteRecord = async (recordId) => {
  await axios.delete(`${API}/records/${recordId}`, { withCredentials: true });
};

export const deleteAllRecords = async () => {
  await axios.delete(`${API}/records`, { withCredentials: true });
};

export const deleteAccount = async () => {
  await axios.delete(`${API}/account`, { withCredentials: true });
};
